import React from "react";
import { Trans, useTranslation } from "react-i18next";
import "./LegalNotice.scss";
import AppContainer from "../../components/app-container/AppContainer";
import { useDocumentTitle } from "../../components/title/DocumentTitle";

const LegalNotice = () => {
    const { t } = useTranslation();

    useDocumentTitle(t("PAGE_LEGAL.TITLE"));

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <div className={"legal-notice-page"}>
                    <h1 role="heading">
                        <Trans i18nKey="PAGE_LEGAL.TITLE" />
                    </h1>
                    <Trans
                        i18nKey="PAGE_LEGAL.CONTENT"
                        components={{
                            link_1: <a href={t("PAGE_LEGAL.LINK_1")} />,
                            link_2: <a href={t("PAGE_LEGAL.LINK_2")} />,
                        }}
                    />
                </div>
            </AppContainer>
        </>
    );
};

export default LegalNotice;
